require("./global.css");

export { default as wrapRootElement } from "./src/redux/ReduxWrapper";
